import p from './training-report.vue';

export default p;
